import React from 'react';
import classNames from 'classnames';
import AspectRatioBox from '@components/shared/AspectRatioBox/AspectRatioBox';
import { SrcSetPicture } from '@components/shared/Picture';
import DeferredImage from '@components/shared/images/atoms/Image/DeferredImage';
import { SrcSet } from '@lib/image';
import breakpoints from '@constants/breakpoints';
import { useMinBreakpoint } from '@hooks/useMediaQuery/useMediaQuery';
import styles from './ShopBanner.module.scss';

function getSrcSetForViewport(url: string) {
  const mobileSrcSets: Record<string, SrcSet> = {};
  ['webp', 'jpeg'].forEach((format) => {
    mobileSrcSets[format] =
      new SrcSet({
        sizes: new Map([
          [SrcSet.DEFAULT, [1920, 1920]],
          [`${breakpoints['large-phone']}`, [640, 640]],
          [`${breakpoints['large-tablet']}`, [960, 960]],
        ]),
        url,
        props: {
          fit: 'fit-in',
          quality: 99,
          format,
        }
      });
  });

  return mobileSrcSets;
}

const ShopBanner = () => {
  const isDektop = useMinBreakpoint(breakpoints.desktop);

  const aspectRatio = isDektop ? 0.26 : 0.44;

  return (
    <section className={classNames(styles.ContentWrapper)}>
      <AspectRatioBox className={styles.ImageWrapper} aspectRatio={aspectRatio}>
        <SrcSetPicture
          srcSets={getSrcSetForViewport('https://s3.amazonaws.com/static.havenly.com/content/backgrounds/shop_banner.jpg')}
          defaultWidth={1920}
          render={({ imgProps }) => (
            <DeferredImage
              className={styles.Image}
              imgProps={{
                ...imgProps,
                alt: 'Background Banner'
              }}
            />
          )}
        />
      </AspectRatioBox>
      <div className={ styles.ContentContainer }>
        <h2 className={ classNames(styles.Title) }>
          {'Shop Designer-Picked Furniture & Decor'}
        </h2>
        <a
          className={classNames(styles.Link)}
          href={'/shop'}
        >
          Shop Havenly
        </a>
      </div>
    </section>
  );
};

export default ShopBanner;
